module.exports = __webpack_public_path__ + "static/img/蒙版组 270@2x.d28f1590.png";